import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { v4 as uuidv4 } from 'uuid';
import TableListEditableNew from '@/components/UI/TableListEditable/TableListEditableNew';
import { ASC_ORDER } from '@/helpers/constants';

const useStyles = makeStyles(() => ({
  content: {
    paddingTop: 0,
    width: '425px',
    minHeight: '15vw',
  },
}));

interface DialogDataSelectionProps {
  dataToSelect: any;
  columns: any[];
  columnSort?: string;
  title: string;
  onClose: () => void;
  onSave: (data: any) => void;
  customContentStyle?: string;
}

const DialogDataSelection: React.FC<DialogDataSelectionProps> = (props) => {
  const { dataToSelect, columns = [], columnSort, title = '', onClose, onSave, customContentStyle } = props;

  const { t } = useTranslation();
  const [tableData, setTableData] = useState<any[]>([]);
  const [selection, setSelection] = useState<number[]>([]);
  const classes = useStyles();

  const handleSelectRow = (slctn: number[]) => setSelection(slctn);
  const handleClose = (reason: string) => (reason && reason === 'backdropClick' && onClose());

  const optionsSelected = tableData.filter((row: any) => selection.includes(row.uuid));

  useEffect(() => {
    setTableData(dataToSelect.map((d) => ({ ...d, uuid: uuidv4() })));
  }, [dataToSelect]);

  return (
    <Dialog open maxWidth="md" onClose={handleClose} disableEnforceFocus disableEscapeKeyDown>
      <DialogTitle>{title}</DialogTitle>
      <DialogContent className={customContentStyle || classes.content}>
        <TableListEditableNew
          list={tableData}
          columns={columns}
          columnId="uuid"
          hasCheckbox
          columnSorting={[{ columnName: columnSort || columns[0]?.name, direction: ASC_ORDER }]}
          onSelectionChange={(selectedRows) => handleSelectRow(selectedRows as number[])}
          selection={selection}
          isPaginated={false}
        />
      </DialogContent>
      <DialogActions>
        <Button id="close-choose-combination" color="primary" onClick={onClose}>
          {t('dialog.cancel')}
        </Button>
        <Button
          id="save-choose-combination"
          disabled={optionsSelected.length === 0}
          variant="contained"
          color="primary"
          onClick={() => onSave(optionsSelected)}
        >
          {t('dialog.save')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DialogDataSelection;
